/**
 * Checks if the given value is a number.
 *
 * @param	value	The value to check.
 * @returns	{boolean} If the value is a number True is returned otherwise False.
 */
function isNumber(value) {
  let isNumeric = /^\d+$/;
  return isNumeric.test(value);
}